class People {
  host: Element;
  calloutContainer?: HTMLElement;
  activeCardClass: string;
  slides: NodeListOf<HTMLElement>;
  nextButton?: HTMLElement;
  prevButton?: HTMLElement;
  touchstartX: number;
  touchendX: number;
  padding: number;
  isMobile: boolean;

  constructor(host: Element) {
    this.host = host;
    this.padding = 16;
    this.activeCardClass = "is-selected";
    this.slides = this.host.querySelectorAll(".vs-person");
    this.calloutContainer =
      this.host.querySelector(".callout-container") || undefined;
    this.isMobile = window.innerWidth < 768;
    this.touchstartX = 0;
    this.touchendX = 0;
    this.host.addEventListener("touchstart", (event) => {
      const e = event as TouchEvent;
      this.touchstartX = e.changedTouches[0].screenX;
    });

    this.host.addEventListener("touchend", (event) => {
      const e = event as TouchEvent;
      this.touchendX = e.changedTouches[0].screenX;
      this.checkDirection();
    });
  }

  checkDirection() {
    if (this.touchendX < this.touchstartX) return "left";
    if (this.touchendX > this.touchstartX) return "right";
  }

  updateData(slide: HTMLElement) {
    if (!this.calloutContainer) return;
    const callout = this.calloutContainer.querySelector(
      ".vs-callout"
    ) as HTMLElement;
    callout.innerHTML = "";
    const name = slide.dataset.personName;
    const title = slide.dataset.personTitle;
    const since = slide.dataset.personSince;

    callout.innerHTML = `<div class="title">${name}</div><div class="text">${title}</div><div class="subtext">${since}</div>`;
  }

  createCallout(slide: HTMLElement) {
    if (!this.calloutContainer) return;
    const triangle = document.createElement("div");
    const callout = document.createElement("div");
    callout.classList.add("vs-callout");
    triangle.classList.add("vs-triangle");

    this.calloutContainer.appendChild(callout);
    this.calloutContainer.appendChild(triangle);

    this.updateData(slide);
  }

  moveCallout(slide: HTMLElement) {
    this.slides.forEach((slide) => slide.classList.remove("is-selected"));
    slide.classList.add("is-selected");
    if (!this.calloutContainer) return;
    const triangle = this.calloutContainer.querySelector(
      ".vs-triangle"
    ) as HTMLElement;
    const callout = this.calloutContainer.querySelector(
      ".vs-callout"
    ) as HTMLElement;
    if (!triangle) return;

    this.updateData(slide);

    const left = slide.offsetLeft;
    const slideRect = slide.getBoundingClientRect();
    const slideCenter = left + slideRect.width / 2;

    const triangleRect = triangle.getBoundingClientRect();
    const triangleWidth = triangleRect.width;

    const calloutRect = callout.getBoundingClientRect();
    const calloutWidth = calloutRect.width;

    const trianglePos = slideCenter - triangleWidth / 2;
    const calloutPos = slideCenter - calloutWidth / 2;
    triangle.style.left = `${trianglePos}px`;
    if (calloutPos < 0) {
      callout.style.left = `${this.padding}px`;
    } else if (calloutPos + calloutWidth > this.calloutContainer.offsetWidth) {
      callout.style.left = `${
        this.calloutContainer.offsetWidth - calloutWidth - this.padding
      }px`;
    } else {
      callout.style.left = `${calloutPos}px`;
    }
  }

  init() {
    if (!this.isMobile) {
      this.slides.forEach((slide) => {
        slide.addEventListener("click", () => {
          this.moveCallout(slide);
        });
      });

      this.createCallout(this.slides[2]);
      this.moveCallout(this.slides[2]);
    } else {
      this.slides.forEach((slide) => {
        const observer = new IntersectionObserver(
          (entries) => {
            if (entries[0].isIntersecting) {
              slide.classList.add("is-selected");
              this.updateData(slide);
            } else {
              slide.classList.remove("is-selected");
            }
          },
          { rootMargin: "0px -50% 0px -50%" }
        );
        observer.observe(slide); // Asynchronous call
      });
      
      this.createCallout(this.slides[0]);
      this.moveCallout(this.slides[0]);
    }
  }
}

(() => {
  const elements = document.querySelectorAll(".vs-people");

  if (elements) {
    elements.forEach((element) => {
      const slider = new People(element);
      slider.init();
    });
  }
})();
